var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"border-b"},[_c('div',{staticClass:"container mx-auto px-6 py-3 sm:py-4 xl:px-14"},[_c('div',{staticClass:"flex flex-wrap items-center justify-center"},[_c('div',[_c('img',{staticClass:"h-5 w-48 sm:h-8 sm:w-64",attrs:{"src":require("@/assets/images/logo.svg")}})])])])])
}]

export { render, staticRenderFns }